import { communityStats } from '@/mocks/faq';

export default function CommunityStats() {
  return (
    <section className="py-14 md:py-20 relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-primary-500/8 via-accent-500/5 to-secondary-500/8"></div>
      <div className="relative max-w-5xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
            社区数据一览
          </h2>
          <p className="text-sm text-foreground-600">
            每一个数字背后，都是一份真实的信任与陪伴
          </p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {communityStats.map((stat, idx) => (
            <div
              key={idx}
              className="text-center p-6 md:p-8 rounded-xl bg-background-50 border border-background-200/70"
            >
              <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-full bg-primary-100 text-primary-600">
                <i className={`${stat.icon} text-xl`}></i>
              </div>
              <div className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-1">
                {stat.value}
              </div>
              <div className="text-xs md:text-sm text-foreground-600">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}